// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"22464ba7","239":"501d68ae","453":"0f601ddc","455":"04a6bf22"}[chunkId] + ".chunk.js";
};